export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-03.017816ca.jpg";